import type {
    TabGroup,
    TabGroupInput,
    TabGroupUpdate,
    ApiResponse,
} from "../lib/types";
import { authenticatedRequest } from "../lib/api";

export async function getTabGroups(token: string): Promise<TabGroup[]> {
    return authenticatedRequest<ApiResponse<TabGroup[]>>(
        "/api/tab-groups",
        token
    ).then((res) => res.data);
}

export async function getTabGroup(
    token: string,
    id: string
): Promise<TabGroup> {
    return authenticatedRequest<ApiResponse<TabGroup>>(
        `/api/tab-groups/${id}`,
        token
    ).then((res) => res.data);
}

export async function createTabGroup(
    token: string,
    input: TabGroupInput
): Promise<TabGroup> {
    return authenticatedRequest<ApiResponse<TabGroup>>("/api/tab-groups", token, {
        method: "POST",
        body: JSON.stringify(input),
    }).then((res) => res.data);
}

export async function updateTabGroup(
    token: string,
    id: string,
    input: TabGroupUpdate
): Promise<TabGroup> {
    return authenticatedRequest<ApiResponse<TabGroup>>(
        `/api/tab-groups/${id}`,
        token,
        {
            method: "PUT",
            body: JSON.stringify(input),
        }
    ).then((res) => res.data);
}

export async function deleteTabGroup(
    token: string,
    id: string
): Promise<void> {
    return authenticatedRequest<void>(`/api/tab-groups/${id}`, token, {
        method: "DELETE",
    });
}
